import { Flex, Stack, Text } from '@mantine/core'

import { useShareContent } from '../ShareChart/hooks'
import { ShareModalContentProps, SocialType } from '../utils'
import styles from './index.module.css'
import TokenPriceShareInfo from './TokenPriceShareInfo'
import {
  getBackgroundImage,
  LION_DESC_COLOR,
  SHARE_CHART_BACKGROUND,
  SHARE_CONTENT_SIZE_MAP,
} from './utils'

export default function TwitterShareContent({
  shareType,
  curTimeRange,
  currentCoinPrices,
  contentContainerRef,
}: ShareModalContentProps) {
  const BackgroundImage = getBackgroundImage(SocialType.twitter, shareType)
  const { shareContent, lionDsc } = useShareContent({
    shareType,
    curTimeRange,
    currentCoinPrices,
  })
  return (
    <Flex
      ref={contentContainerRef}
      {...SHARE_CONTENT_SIZE_MAP[SocialType.twitter]}
      align="center"
      pos="relative"
    >
      <Stack w={570} h={'100%'} align={'center'} pt={112}>
        <TokenPriceShareInfo
          change={currentCoinPrices?.usd_price_change ?? 0}
          timeRange={curTimeRange}
          fontSizeConfig={{
            title: 40,
            price: 45,
            change: 32,
            timeRange: 32,
          }}
        />
        <Text mt={75} className={styles.lionDsc} c={LION_DESC_COLOR}>
          {lionDsc}
        </Text>
      </Stack>

      <Flex w={570} h={569} bg={SHARE_CHART_BACKGROUND}>
        {shareContent}
      </Flex>
      <BackgroundImage className={styles.shareBackground} />
    </Flex>
  )
}
